import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ExportButton } from "../../../../../components/common/Buttons";

const TABS = [
  { value: "all",        label: "All",              countKey: "inPool"    },
  { value: "fullyfree",  label: "Fully Free",       countKey: "fullyFree" },
  { value: "over30days", label: "In Pool >30 days", countKey: null        },
];

const FilterTabs = ({ active, summary, onSelect, search, onSearchChange, onExport, exportDisabled }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box sx={{
      display: "flex", alignItems: "center",
      justifyContent: "space-between",
      padding: "10px 20px",
      borderBottom: `1px solid ${t.border2}`,
      flexWrap: "wrap", gap: "10px",
      flexShrink: 0,
    }}>

      <Box sx={{ display: "flex", gap: "6px" }}>
        {TABS.map((tab) => {
          const isActive = active === tab.value;
          const count    = tab.countKey ? summary?.[tab.countKey] : null;

          return (
            <Box
              key={tab.value}
              onClick={() => onSelect(tab.value)}
              sx={{
                display: "flex", alignItems: "center", gap: "5px",
                padding: "5px 14px", borderRadius: "4px",
                cursor: "pointer", transition: "all 0.15s",
                border: isActive
                  ? `1px solid ${t.accent}66`
                  : `1px solid ${t.border2}`,
                background: isActive ? t.accent2 : "transparent",
                "&:hover": { background: t.surface2, borderColor: t.border3 },
              }}
            >
              <Typography sx={{
                fontFamily: "'Inter', sans-serif",
                fontSize: "12px", fontWeight: isActive ? 600 : 400,
                color: isActive ? t.accent : t.text2,
              }}>
                {tab.label}
              </Typography>
              {count != null && (
                <Typography sx={{
                  fontFamily: "'DM Mono', monospace",
                  fontSize: "10px",
                  color: isActive ? t.accent : t.text3,
                }}>
                  ({count})
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>

      {/* Search & Export */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Box sx={{
          display: "flex", alignItems: "center", gap: "8px",
          background: t.surface2, border: `1px solid ${t.border2}`,
          borderRadius: "4px", padding: "6px 12px", width: "240px",
        }}>
          <Box sx={{ color: t.text3, display: "flex", alignItems: "center" }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
          </Box>
          <input
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search name, skill, level..."
            style={{
              flex: 1, background: "transparent", border: "none", outline: "none",
              fontFamily: "'Inter', sans-serif", fontSize: "12px",
              color: "inherit",
            }}
          />
        </Box>

        <ExportButton
          label="Export"
          onClick={onExport}
          disabled={exportDisabled}
        />
      </Box>
    </Box>
  );
};

export default FilterTabs;